import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";
import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";
import InputNumber from "../../../../../../../ui/input/input-number";

interface ISelectionByOwnSwapStep_1 {
  isNextStepDisabled: boolean;
  data: number | null;
  onChange: (data: number, key: TNumberKeysOfIFillDataWizardBuy) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnSwapStep_1 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: ISelectionByOwnSwapStep_1) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.step_3);
    onReset(["apartmentNumber"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_2);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        nextStep={handleNexStep}
        text="Укажите номер квартиры:"
        isNextStepDisabled={isNextStepDisabled}
      >
        <InputNumber
          value={data ? String(data) : ""}
          onChange={(value) => onChange(Number(value), "apartmentNumber")}
          label="Номер квартиры"
          placeholder="Например: 42"
          mode="apartment"
          isMainPlaceholder
        />
      </BaseStep>
    </div>
  );
};

export default SelectionByOwnSwapStep_1;
